var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExclamationBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3499_42988)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "translate(0.5 0.5)",
    fill: "#FAFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4998 73.8334C22.0898 73.8334 7.1665 58.91 7.1665 40.5C7.1665 22.09 22.0898 7.16669 40.4998 7.16669C58.9098 7.16669 73.8332 22.09 73.8332 40.5C73.8332 58.91 58.9098 73.8334 40.4998 73.8334ZM40.4998 67.1667C47.5723 67.1667 54.355 64.3572 59.356 59.3562C64.357 54.3552 67.1665 47.5725 67.1665 40.5C67.1665 33.4276 64.357 26.6448 59.356 21.6438C54.355 16.6429 47.5723 13.8334 40.4998 13.8334C33.4274 13.8334 26.6446 16.6429 21.6437 21.6438C16.6427 26.6448 13.8332 33.4276 13.8332 40.5C13.8332 47.5725 16.6427 54.3552 21.6437 59.3562C26.6446 64.3572 33.4274 67.1667 40.4998 67.1667ZM37.1665 51.5C37.1665 50.9477 37.6142 50.5 38.1665 50.5H42.8332C43.3855 50.5 43.8332 50.9477 43.8332 51.5V56.1667C43.8332 56.719 43.3855 57.1667 42.8332 57.1667H38.1665C37.6142 57.1667 37.1665 56.719 37.1665 56.1667V51.5ZM37.1665 24.8334C37.1665 24.2811 37.6142 23.8334 38.1665 23.8334H42.8332C43.3855 23.8334 43.8332 24.2811 43.8332 24.8334V42.8334C43.8332 43.3856 43.3855 43.8334 42.8332 43.8334H38.1665C37.6142 43.8334 37.1665 43.3856 37.1665 42.8334V24.8334Z",
    fill: "#C6D5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3499_42988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamationBlue);
export default __webpack_public_path__ + "static/media/icon-exclamation-blue.4cb256aa3ab6bea9d2c747485c1787f9.svg";
export { ForwardRef as ReactComponent };